import { FunctionComponent } from 'react'
import { WTitle, WParagraph, WButton } from '@alice-health/wonderland-react'
import { MAP_ERROR_MESSAGE_MODAL_ID } from './ApiErrorMessageModal.constants'
import { useMarkers } from '@/modules/accredited-establishments/hooks'
import { ErrorModalTemplate } from '@/modules/accredited-establishments/components/Maps/ErrorModalTemplate'

const ApiErrorMessageModal: FunctionComponent = () => {
  const { refetch, isError } = useMarkers()

  return (
    <ErrorModalTemplate
      id={MAP_ERROR_MESSAGE_MODAL_ID}
      active={isError}
    >
      <WTitle
        className='text-center pt-2'
        size='small'
      >
        Algo deu errado ao carregar as informações
      </WTitle>

      <WParagraph mode='secondary'>
        Tente novamente em instantes ou atualize a página.
      </WParagraph>

      <WButton
        variant='primary'
        size='large'
        icon='icUpdate'
        onClick={() => refetch()}
      >
        Tentar novamente
      </WButton>
    </ErrorModalTemplate>
  )
}

export { ApiErrorMessageModal }
